import { createRouter, createWebHistory } from 'vue-router'
import Pricing from '../views/Pricing.vue'
import Contact from '../views/Contact.vue'
import About from '../views/About.vue'
import EventApp from '../views/features/EventApp.vue'
import LeadCapture from '../views/features/LeadCapture.vue'
import StyleGuide from '../views/StyleGuide.vue'
import HomePage from '../views/HomePage.vue'
import Components from '../views/Components.vue'
import Blocks from '../views/Blocks.vue'
import StyleGuideSoftware from '../views/StyleGuideSoftware.vue'
import Overview from '../views/Overview.vue'
import BadgesAndKiosks from '../views/features/BadgesAndKiosks.vue'
import AttendanceTracking from '../views/features/AttendanceTracking.vue'
import RegistrationAndTickets from '../views/features/RegistrationAndTickets.vue'
import WebsitesBuilder from '../views/features/WebsitesBuilder.vue'
import AudienceParticipation from '../views/features/AudienceParticipation.vue'
import EmailsAndCommunications from '../views/features/EmailsAndCommunications.vue'
import MeetingsAndNetworking from '../views/features/MeetingsAndNetworking.vue'
import InteractiveFloorplans from '../views/features/InteractiveFloorplans.vue'
import SpeakerPortals from '../views/features/SpeakerPortals.vue'
import CompanyPortals from '../views/features/CompanyPortals.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import SupplyTerms from '../views/SupplyTerms.vue'
import FindAPartner from '../views/FindAPartner.vue'
import BecomeAPartner from '../views/BecomeAPartner.vue'
import Signup from '../views/Signup.vue'
const routes = [
  {
    path: '/',
    name: 'Base',
    component: HomePage,
    meta: { title: 'Entegy - Event Management Platform' }
  },
  {
    path: '/styleguide',
    name: 'StyleGuide',
    component: StyleGuide,
    meta: { title: 'Style Guide - Entegy' }
  },
  {
    path: '/styleguide/software',
    name: 'StyleGuideSoftware',
    component: StyleGuideSoftware,
    meta: { title: 'Style Guide - Entegy' }
  },
  {
    path: '/blocks',
    name: 'Blocks',
    component: Blocks,
    meta: { title: 'Blocks - Entegy' }
  },
  {
    path: '/components',
    name: 'Components',
    component: Components,
    meta: { title: 'Components - Entegy' }
  },
  {
    path: '/entegy/web',
    name: 'EntegyWeb',
    component: HomePage,
    meta: { title: 'Entegy - Event Management Platform' }
  },
  {
    path: '/features/eventapp',
    name: 'EventApp',
    component: EventApp,
    meta: { title: 'Event App - Entegy' }
  },
  {
    path: '/features/leadcapture',
    name: 'LeadCapture',
    component: LeadCapture,
    meta: { title: 'Lead Capture - Entegy' }
  },
  {
    path: '/features/badgesandkiosks',
    name: 'BadgesAndKiosks',
    component: BadgesAndKiosks,
    meta: { title: 'Badges & Kiosks - Entegy' }
  },
  {
    path: '/features/attendancetracking',
    name: 'AttendanceTracking',
    component: AttendanceTracking,
    meta: { title: 'Attendance Tracking - Entegy' }
  },
  {
    path: '/features/registrationandtickets',
    name: 'RegistrationAndTickets',
    component: RegistrationAndTickets,
    meta: { title: 'Registration & Tickets - Entegy' }
  },
  {
    path: '/features/websitesbuilder',
    name: 'WebsitesBuilder',
    component: WebsitesBuilder,
    meta: { title: 'Website Builder - Entegy' }
  },
  {
    path: '/features/audienceparticipation',
    name: 'AudienceParticipation',
    component: AudienceParticipation,
    meta: { title: 'Audience Participation - Entegy' }
  },
  {
    path: '/features/emailsandcommunications',
    name: 'EmailsAndCommunications',
    component: EmailsAndCommunications,
    meta: { title: 'Emails & Communications - Entegy' }
  },
  {
    path: '/features/meetingsandnetworking',
    name: 'MeetingsAndNetworking',
    component: MeetingsAndNetworking,
    meta: { title: 'Meetings & Networking - Entegy' }
  },
  {
    path: '/features/interactivefloorplans',
    name: 'InteractiveFloorplans',
    component: InteractiveFloorplans,
    meta: { title: 'Interactive Floorplans - Entegy' }
  },
  {
    path: '/features/speakerportals',
    name: 'SpeakerPortals',
    component: SpeakerPortals,
    meta: { title: 'Speaker Portals - Entegy' }
  },
  {
    path: '/features/companyportals',
    name: 'CompanyPortals',
    component: CompanyPortals,
    meta: { title: 'Company Portals - Entegy' }
  },
  {
    path: '/overview',
    name: 'Overview',
    component: Overview,
    meta: { title: 'Overview - Entegy' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: { title: 'Contact - Entegy' }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { title: 'About - Entegy' }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: { title: 'Privacy Policy - Entegy' }
  },
  {
    path: '/supply-terms',
    name: 'SupplyTerms',
    component: SupplyTerms,
    meta: { title: 'Supply Terms - Entegy' }
  },
  {
    path: '/find-a-partner',
    name: 'FindAPartner',
    component: FindAPartner,
    meta: { title: 'Find a Partner - Entegy' }
  },
  {
    path: '/become-a-partner',
    name: 'BecomeAPartner',
    component: BecomeAPartner,
    meta: { title: 'Become a Partner - Entegy' }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: { title: 'Sign Up for a Free Account - Entegy' }
  },
  // Catch-all: unmatched routes go to home
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Update page title
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Entegy - Event Management Platform'
  next()
})

export default router 